import React from 'react'

import { Text, Tooltip, Icon } from '@components/UI'

import { Export } from './Tools'

const Actions = ({
  close,

  file,
  exportConfig,
  exportToSketch,
  expanded,
  expand
}) => {
  return (
    <div className='gp-preview-header-actions'>
      {!['link'].includes(file.type) && (
        <Export
          type={file.type}
          url={file.data}
          name={file.name}
          config={exportConfig}
          exportToSketch={exportToSketch}
          visibility={file.visibility}
        />
      )}
      <div className='control-container dark'>
        {expanded ? (
          <button onClick={() => expand(false)}>
            <Icon name='shrink vertical' />
          </button>
        ) : (
          <button onClick={() => expand(true)}>
            <Icon name='spread vertical' />
          </button>
        )}
        <Tooltip
          content={
            <Text
              className='text-c semibold'
              style={{ lineHeight: 1, opacity: 0.5 }}
            >
              {expanded ? 'Hide Description' : 'Show Description'}
            </Text>
          }
          group={close ? 'c7' : 'c8'}
          className='theme color-f background-a info border'
        />
      </div>
      {!!close && (
        <div className='gp-preview-header-exit'>
          <div className='control-container dark'>
            <button onClick={close}>
              <Icon name='close' />
            </button>
          </div>
        </div>
      )}
    </div>
  )
}

export default Actions
